
export function isEventActive(event) {
  const now = new Date();
  const startDate = event.startDate.toDate();
  const endDate = event.endDate.toDate();
  return now >= startDate && now <= endDate;
}

export function isEventUpcoming(event) {
  const now = new Date();
  const startDate = event.startDate.toDate();
  return now < startDate;
}

export function formatEventDate(event) {
    if (!event || !event.startDate || !event.endDate) {
        return "";
    }
    const startDate = event.startDate.toDate();
    const endDate = event.endDate.toDate();
    
    const startDateString = `${startDate.getDate().toString().padStart(2, '0')}/${(startDate.getMonth() + 1).toString().padStart(2, '0')}`;
    const endDateString = `${endDate.getDate().toString().padStart(2, '0')}/${(endDate.getMonth() + 1).toString().padStart(2, '0')}`;


    if (startDate.getFullYear() === endDate.getFullYear() && startDate.getMonth() === endDate.getMonth() && startDate.getDate() === endDate.getDate()) {
        return startDateString;
    }
    
    return `${startDateString}-${endDateString}`;
}
